/**
 * Turns a DOM element into a PDF and hands it to the browser as a download.
 *
 * html2pdf's own save() resolves without telling anyone whether a file was
 * actually delivered, which in some browsers (embedded webviews especially)
 * means a click that does nothing at all. Building the blob first and firing
 * the download ourselves keeps the whole thing awaitable, so callers can show
 * a busy state for as long as the work really takes and report failure.
 *
 * html2pdf.js is browser-only and heavy, so it is imported on demand rather
 * than shipped in the initial bundle or evaluated during server-side rendering.
 */
export const saveElementAsPdf = async (element, { filename, ...options }) => {
  const { default: html2pdf } = await import('html2pdf.js');

  const blob = await html2pdf()
    .set({ filename, ...options })
    .from(element)
    .output('blob');

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Give the browser time to start the download before the URL is released.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
};
